// TODO: Write tests for this file

export const DOCS_PATHNAME_PART = "federated-modules-docs";

export const DOCS_ID = "fabric-federated-modules-docs";
